import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalMenuTaskDisplayModeButtonGroup } from 'enums/app'

type TaskListPageStateType = {
  selectedGlobalMenuTaskListDisplayMode: string
}

const initialTaskListPageState: TaskListPageStateType = {
  selectedGlobalMenuTaskListDisplayMode:
    GlobalMenuTaskDisplayModeButtonGroup.List.id,
}

export const taskListPageSlice = createSlice({
  name: 'taskListPage',
  initialState: initialTaskListPageState,
  reducers: {
    setSelectedGlobalMenuTaskListDisplayMode: (
      state,
      action: PayloadAction<string>
    ) => {
      state.selectedGlobalMenuTaskListDisplayMode = action.payload
    },
  },
})

export const { setSelectedGlobalMenuTaskListDisplayMode } =
  taskListPageSlice.actions
